// Added By Jaseem => Report Month Filter Bar (CBR Reports — month only, no year)
// Date =:(27-04-2026)
import React from "react";
import { Col, Form, Row } from "react-bootstrap";

const MONTHS = [
  { v: 1, label: "January" },
  { v: 2, label: "February" },
  { v: 3, label: "March" },
  { v: 4, label: "April" },
  { v: 5, label: "May" },
  { v: 6, label: "June" },
  { v: 7, label: "July" },
  { v: 8, label: "August" },
  { v: 9, label: "September" },
  { v: 10, label: "October" },
  { v: 11, label: "November" },
  { v: 12, label: "December" },
];

/** Month-only filter for Reports list pages; when unchecked, parent loads without month filter. */
export default function ReportMonthFilterBar({
  useMonthFilter,
  onUseMonthFilterChange,
  month,
  onMonthChange,
}) {
  return (
    <Row className="mb-3 align-items-end g-2 flex-wrap">
      <Col xs={12} sm="auto">
        <Form.Label className="small text-muted mb-1 d-block">Submission period</Form.Label>
        <Form.Check
          type="checkbox"
          id="limit-by-month"
          className="user-select-none"
          label="select month wise report"
          checked={useMonthFilter}
          onChange={(e) => onUseMonthFilterChange(e.target.checked)}
        />
      </Col>
      {useMonthFilter ? (
        <Col xs={12} sm={4} md={3}>
          <Form.Label className="small text-muted mb-1">Month</Form.Label>
          <Form.Select
            size="sm"
            value={month}
            onChange={(e) => onMonthChange(Number(e.target.value))}
          >
            {MONTHS.map((m) => (
              <option key={m.v} value={m.v}>
                {m.label}
              </option>
            ))}
          </Form.Select>
        </Col>
      ) : null}
    </Row>
  );
}
